import { useEffect, useState } from "react";
import axios from "axios";

// One-line social proof under the hero CTA. Silent on error (decorative).
export default function HeroProofStrip() {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/public/social-proof`)
      .then((r) => setD(r.data))
      .catch(() => {});
  }, []);
  if (!d) return null;
  return (
    <p
      className="mt-4 font-mono text-[11px] md:text-xs text-white/55 tracking-wide fade-up"
      data-testid="hero-proof-strip"
    >
      <span className="text-[#E5FE40] font-bold tabular-nums" data-testid="hero-proof-count">
        {d.unlocks_this_week}
      </span>{" "}
      ideas scored this week <span className="text-white/25">·</span> median{" "}
      <span className="text-white font-bold tabular-nums" data-testid="hero-proof-median">
        {d.median_score}
      </span>
      /100 <span className="text-white/25">·</span> most don&apos;t survive
    </p>
  );
}
